import { rest, RestHandler } from 'msw';
import { generatePaymentsServiceUrl, POLLING_STATUS } from 'adapters/constants';
import { checkWritingResponse, voidResponse } from 'mocks/mockData';

// for successful call
// import { voidResponse } from 'mocks/mockData';

export const checkWritingHandler: RestHandler[] = [
  rest.post(
    `${generatePaymentsServiceUrl()}/vendors/async/*/print-checks`,
    (_, res, ctx) => res(ctx.status(200), ctx.json(12345))
  ),
  rest.get(
    `${generatePaymentsServiceUrl()}/vendors/async/*/print-checks/12345/status`,
    (_, res, ctx) =>
      res(
        ctx.status(200),
        ctx.json({
          status: POLLING_STATUS.COMPLETED,
          current: 1,
          total: 1
        })
      )
  ),
  // rest.get(
  //   `${generatePaymentsServiceUrl()}/vendors/async/*/print-checks/12345/status`,
  //   (_, res, ctx) =>
  //     res(
  //       ctx.status(500),
  //       ctx.set('Content-Type', 'text/plain'),
  //       ctx.text('ERROR: java.lang.Exception: Accounting Setups not found')
  //     )
  // ),
  // rest.post(
  //   `${generatePaymentsServiceUrl()}/vendors/1/print-checks/12345/results`,
  //   (_, res, ctx) =>
  //     res(ctx.status(502), ctx.json({ errorMessage: 'Bad Gateway' }))
  // ),
  // for successful call
  rest.get(
    `${generatePaymentsServiceUrl()}/vendors/async/*/print-checks/12345/results`,
    (_, res, ctx) => res(ctx.status(200), ctx.json(checkWritingResponse))
  ),
  // rest.get(
  //   `${generatePaymentsServiceUrl()}/vendors/async/1/print-checks/12345/results`,
  //   (_, res, ctx) =>
  //     res(ctx.status(200), ctx.json(responseWithPartiallyFailedChecks))
  // ),
  rest.post(
    `${generatePaymentsServiceUrl()}/ap-check/async/*/void-multi`,
    (_, res, ctx) => res(ctx.status(200), ctx.text('12345'))
  ),
  rest.get(
    `${generatePaymentsServiceUrl()}/ap-check/async/*/void-multi/12345/status`,
    (_, res, ctx) =>
      res(
        ctx.status(200),
        ctx.json({
          status: POLLING_STATUS.COMPLETED,
          current: 1,
          total: 1
        })
      )
  ),
  rest.get(
    `${generatePaymentsServiceUrl()}/ap-check/async/*/void-multi/12345/results`,
    (_, res, ctx) => res(ctx.status(200), ctx.json(voidResponse))
  )
];
